export class UserDto {
  constructor(
    public role: number,
    public email: string,
    public password: string,
    public name: string,
    public lastName: string,
    public phone: string,
    public dni: string
  ) {}
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dto/user.dto.ts